import {
  useQuery,
  UseQueryResult,
  useQueryClient,
  useMutation,
  UseMutationResult
} from 'react-query';
import { NewPaginationModel } from '../../../types';
import {
  Campaign,
  CreateCampaignBody,
  PaginatedCampaignParams,
  PartnerClient
} from '../../../partnerClient';

const KEY = 'CAMPAIGN';

const useGetPaginatedList =
  (apiClient: PartnerClient) =>
  (params: PaginatedCampaignParams): UseQueryResult<NewPaginationModel<Campaign>, any> => {
    return useQuery([KEY, params], () => apiClient.loyalty.campaign.getPaginatedList(params));
  };

const useGetCampaign =
  (apiClient: PartnerClient) =>
  (campaignId: number): UseQueryResult<Campaign, any> => {
    return useQuery([KEY, campaignId], () => apiClient.loyalty.campaign.get(campaignId), {
      select: (campaign: Campaign) => campaign
    });
  };

const useUpdateCampaign =
  (apiClient: PartnerClient) =>
  (campaignId: number): UseMutationResult<any, any, CreateCampaignBody, void> => {
    const queryClient = useQueryClient();
    return useMutation(
      (data: CreateCampaignBody) => apiClient.loyalty.campaign.update(campaignId, data),
      {
        onSettled: () => {
          // refetch campaign in background in case it gets updated
          queryClient.invalidateQueries([KEY, campaignId]);
        }
      }
    );
  };

export default (client: PartnerClient) => ({
  useGetPaginatedList: useGetPaginatedList(client),
  useGetCampaign: useGetCampaign(client),
  useUpdateCampaign: useUpdateCampaign(client)
});
